import { FC } from 'react';

import { Loader } from '@base-app';
import { Section, SubPage } from '@builder';
import { Box, Separator } from '@/common/components';

import { loaderStyles } from './ParticipantLayout.styles';
import { ParticipantLayoutProps } from './ParticipantLayout.types';
import SectionSubtitle from '../SectionSubtitle/SectionSubtitle';

const ParticipantLayout: FC<ParticipantLayoutProps> = ({
  children,
  id,
  isLoading,
  sectionTitle,
  labelLeftTop,
  labelLeftBottom,
  labelRightTop,
  labelRightBottom,
  parenthesisSubtitle,
  numberLeft,
  numberRight,
  sideContent,
  subHeader,
  tooltipPartnerEconsent,
  ...props
}) => {
  return (
    <SubPage id={id} data-testid={id} hasSeparator={false} {...props}>
      <Section
        css={{ padding: 0, marginBottom: '$6' }}
        cssTitle={{ margin: 0, maxHeight: 'none' }}
        title={sectionTitle}
        subtitle={
          <SectionSubtitle
            isLoading={isLoading}
            labelLeftTop={labelLeftTop}
            labelLeftBottom={labelLeftBottom}
            labelRightTop={labelRightTop}
            labelRightBottom={labelRightBottom}
            parenthesisSubtitle={parenthesisSubtitle}
            numberLeft={numberLeft}
            numberRight={numberRight}
          />
        }
        cssSubtitle={{ margin: 0, maxHeight: 'none', alignItems: 'center' }}
      >
        {isLoading && (
          <Box data-testid={`${id}-loader`}>
            <Loader css={loaderStyles} />
          </Box>
        )}
        {!isLoading && (
          <Box
            data-testid={`${id}-content-container`}
            css={{ paddingRight: '$6', paddingLeft: '$6', paddingBottom: '$6' }}
          >
            <Separator css={{ my: '$6' }} data-testid={`${id}-separator`} />
            <Box data-testid={`${id}-sub-header`}>{subHeader}</Box>
            {tooltipPartnerEconsent && (
              <Box css={{ margin: '$6' }} data-testid={`${id}-content-tooltip`}>
                {tooltipPartnerEconsent}
              </Box>
            )}
            <Box css={{ display: 'flex', gap: '$6' }}>
              <Box css={{ flexGrow: 1 }} data-testid={`${id}-side-content`}>
                {sideContent}
              </Box>
              <Box css={{ flexGrow: 3 }} data-testid={`${id}-main-content`}>
                {children}
              </Box>
            </Box>
          </Box>
        )}
      </Section>
    </SubPage>
  );
};

export default ParticipantLayout;
